import moment from 'moment';
import 'moment-timezone';

angular.module('am4').filter('dateInTimeZone', function() {

    // Displays a date in a given time zone, along with UTC offset value
    return function(date, time_zone = 'UTC', format = 'lll z (UTCZ)') {
        return moment(date).tz(time_zone).format(format);
    };
});



// WEBPACK FOOTER //
// ./src/app/filters/dateInTimeZone.js